export default [
  {
    value: 1,
    label: 'Sábado após as 6:00',
  },
  {
    value: 2,
    label: 'Sábado após as 7:00',
  },
  {
    value: 3,
    label: 'Sábado após as 8:00',
  },
  {
    value: 4,
    label: 'Sábado após as 9:00',
  },
  {
    value: 5,
    label: 'Sábado após as 10:00',
  },
  {
    value: 6,
    label: 'Sábado após as 11:00',
  },
  {
    value: 7,
    label: 'Sábado após as 12:00',
  },
  {
    value: 8,
    label: 'Sábado após as 13:00',
  },
  {
    value: 9,
    label: 'Sábado após as 14:00',
  },
  {
    value: 10,
    label: 'Sábado após as 15:00',
  },
  {
    value: 11,
    label: 'Sábado após as 16:00',
  },
  {
    value: 12,
    label: 'Sábado após as 17:00',
  },
  {
    value: 13,
    label: 'Sábado após as 18:00',
  },
  {
    value: 14,
    label: 'Sábado após as 19:00',
  },
  {
    value: 15,
    label: 'Sábado após as 20:00',
  },
];
